import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //報名死線
    signDeadline: '2022-09-30 23:59:59',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
